"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const auth_1 = require("companion-app-components/flux/auth");
const Logout = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(() => {
        dispatch(auth_1.authActions.authLogout({ reason: 'AUTH_LOGOUT_ROUTE' }, { context: 'url' }));
    }, [dispatch]);
    return null;
};
exports.default = Logout;
